import { Component } from '@angular/core';

@Component({
  selector: 'a18-scheduler',
  templateUrl: './a18-scheduler.component.html',
  styleUrl: './a18-scheduler.component.scss'
})
export class A18SchedulerComponent {

}
